<template>
<div>
  {{$t('Showing')}} <span v-text="pagination.from"></span> {{$t('to')}} <span v-text="pagination.to"></span> {{$t('of')}}  <span v-text="pagination.total"></span>
  <ul class="pagination">
    <!--REVENIR A LA PREMIERE PAGE ====================================================================================================================================-->
    <li class="pagination-item">
      <button type="button" @click="changePage(1)" :disabled="isInFirstPage" class="mainBtn mainBtnFirst prevNext">&lt;&lt;</button>
    </li>

    <!--PAGE PRÉCÉDENTE ====================================================================================================================================-->
    <li class="pagination-item">
      <button type="button" @click="changePage(pagination.currentPage-1)" :disabled="isInFirstPage" class="mainBtn prevNext">&lt;</button>
    </li>

    <li v-for="(page, index) in filteredPages" :key="index" class="pagination-item">
      <button type="button" @click="onClickPage(page)" class="mainBtn" :class="{ active: isCurrentPageActive(page.name) }">
        {{ page.name }}
      </button>
    </li>

    <!--PAGE SUIVANTE ====================================================================================================================================-->
    <li class="pagination-item">
      <button class="mainBtn prevNext" type="button" @click="changePage(pagination.currentPage+1)" :disabled="isInLastPage">&gt;</button>
    </li>

    <!--DERNIERE PAGE ====================================================================================================================================-->
    <li class="pagination-item">
      <button class="mainBtn mainBtnLast prevNext" type="button" @click="changePage(pagination.lastPage)" :disabled="isInLastPage">
        &gt;&gt;
      </button>
    </li>
  </ul>
</div>
</template>

<script>


export default {
  props: {
    maxVisibleButtons: {
      type: Number,
      required: false,
      default: 3
    },    
    perPage: {
      type: Number,
      required: true,
      default: 20
    },
    currentPage: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    }
  },
  components: {
    //SvgIcon
  },
  data() {
    return {
      pagination: {
                total: 0,
                lastPage : 1,
                perPage: this.perPage,
                currentPage: 1,
                from: 1,
                to: 1 * this.perPage,
                limitStart : 0,
                limitEnd : 0

            },
    }
  },
  computed: {
    filteredPages() {
      return this.getPages.filter(p => p.isVisible == true); 
    },
    getPages() {
      let  pages = []
      for ( let i = 1; i <= this.pagination.lastPage; i++ ) {
        pages.push({
          name: i,
          isDisabled: i === this.pagination.currentPage,
          isVisible: true,
          isDotBtn : false
        });
      }

      pages = pages.map(page => {
                          page.isVisible = page.name >= this.pagination.limitStart && page.name <= this.pagination.limitEnd
                          return page;
                      });

      return pages
    },
    getCurrentOffset() { //En fonction de la page courrante, cette fonction détecte la limite du nombre de boutons à afficher
      return Math.ceil((this.pagination.currentPage - this.maxVisibleButtons) / this.maxVisibleButtons)
    },  
    getOffsetCount() { 
      return Math.ceil(this.pagination.lastPage / this.maxVisibleButtons) - 1
    },  
    isInFirstPage() {
      return this.pagination.currentPage === 1;
    },
    isInLastPage() {
      return this.pagination.currentPage === this.pagination.lastPage;
    },
  },
  methods: {
    onClickPage(page) {
      if(page.isDotBtn) {
        if(this.getCurrentOffset > 0 && this.getCurrentOffset <= this.getOffsetCount) {
          //Aller au boutons précédent
          //let t = this.pagination.limitStart - this.maxVisibleButtons
          //this.changePage(t)
        }
        if(this.getCurrentOffset >= 0 && this.getCurrentOffset < this.getOffsetCount) {
          //Aller au boutons suivant
          this.changePage(this.pagination.limitStart + this.maxVisibleButtons)
        }
      } else { this.changePage(page.name) }
    },
    changePage(page) {
      this.pagination.currentPage = page
      this.$emit('pagechanged', this.pagination.currentPage);
    },
    isCurrentPageActive(page) {
      return this.pagination.currentPage === page;
    },
    changeView() {
      this.pagination.currentPage = 1
      this.pagination.limitStart = 0
      this.pagination.limitEnd = 0
    },
    refreshPagination() {
      this.pagination.total = this.total;
      this.pagination.perPage = this.perPage;
      this.pagination.lastPage = Math.ceil(this.pagination.total / this.pagination.perPage);

      if (this.pagination.currentPage >= 1 && this.pagination.currentPage <= this.pagination.lastPage) {
        this.pagination.from = (this.pagination.currentPage - 1) * this.perPage + 1
        this.pagination.to = (this.pagination.currentPage) * this.perPage
        if (this.pagination.currentPage === this.pagination.lastPage) {
          this.pagination.to = this.pagination.total
        }
      }

      if(this.getCurrentOffset > 0 ) {
        this.pagination.limitStart = (this.getCurrentOffset * this.maxVisibleButtons) + 1
        this.pagination.limitEnd = this.pagination.limitStart + this.maxVisibleButtons
      } else {
        this.pagination.limitStart = 1
        this.pagination.limitEnd = this.maxVisibleButtons
      }
    },
  },
  mounted() {
      this.refreshPagination()
  },
  watch: {
    perPage: function() {
      this.changeView()
      this.refreshPagination()
    },
    'pagination.currentPage': function() {
      this.refreshPagination()
    },
    }
  }
</script>

<style lang="scss" scoped>
.mainBtn{
  padding-left: 5px;
  padding-right: 5px;
  color: black;
  border: 1px solid black;
  background: transparent;
  width: 30px;
  height: 27px
}

.prevNext{
  background: $SecondaryColor;
}

.mainBtnFirst{
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}
.mainBtnLast{
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}

.pagination {
  list-style-type: none;
  }

.pagination-item {
  display: inline-block;
}

.active {
  padding-left: 5px;
  padding-right: 5px;
  color: $ServexWhite;
  border: 1px solid black;
  background: $MainColor;
  width: 30px;
  height: 27px
}
</style>